import { faCheck, faHandPointRight, faPhone, faPlane, faPlay, faStopwatch, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import swal from 'sweetalert';
import JobTeachers from './JobTeachers';

const JobPreperationDetails = () => {
    const { id } = useParams();
    const [course, setCourse] = useState({});
    const [loaddig, setLoadding] = useState(true);




    //load single course details 
    useEffect(() => {
        fetch(`https://one0m-backend2.onrender.com/job/single/${id}`)
            .then(res => res.json())
            .then(data => {
                setCourse(data?.jobID);
                setLoadding(false)
            })
            .catch(err => {
                setLoadding(true)
            })
    }, [id])

    //HandleBuy
    const handleBuy = () => {
        swal("WOW!", "কোর্সটি সম্পর্কে বিস্তারিত জানতে ফোন করুন 16910!", "success");
    }



    return (
        <section className='just' style={{ marginTop: '80px' }}>
            {
                loaddig ? <>

                    <div class="d-flex justify-content-center">
                        <div class="spinner-grow text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-secondary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-success" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-danger" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-warning" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-info" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-dark" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>

                </>

                    :

                    <div className='just container-fluid p-5 courseDetails'>
                        <div className="row">
                            <div className="col-lg-8 col-md-6 col-sm-6 col-12">
                                <div className="course-content">
                                    <h2 className='fw-bold'>{course?.courseTitle}</h2>
                                    <h5 className='mb-3 mt-5 fw-bold'>কোর্স ইন্সট্রাক্টর</h5>
                                    <div className="instactor-profile cBorder p-3">
                                        <div className="row gy-3">
                                            {
                                                course?.teachersProfile?.map(tea => <JobTeachers tea={tea} key={tea._id} />)
                                            }
                                        </div>
                                    </div>
                                    <div className="whybuy">
                                        <h5 className='fw-bold mt-5 mb-3'>কোর্সটি সম্পর্কে</h5>
                                        <p className='cBorder p-3 text-secondary fs-5'>{course?.aboutCourse}</p>
                                    </div>
                                    <div className="got-certificate mt-5">
                                        <h5 className='fw-bold mb-3'>সার্টিফিকেট পেতে আজই শেখা শুরু করুন</h5>
                                        <div className="cBorder p-3">
                                            <p className='fs-4'>কোর্সটি সফলভাবে শেষ করলে আপনার জন্য আছে সার্টিফিকেট যা আপনি-</p>
                                            <ul className='mb-3 mt-2 text-secondary outline'>
                                                <li className='mb-1'><FontAwesomeIcon icon={faCheck} className='text-success me-2' />আপনার সিভিতে যোগ করতে পারবেন</li>
                                                <li className='mb-1'><FontAwesomeIcon icon={faCheck} className='text-success me-2' />লিংকডইন প্রোফাইলে সরাসরি শেয়ার করতে পারবেন</li>
                                                <li className='mb-1'><FontAwesomeIcon icon={faCheck} className='text-success me-2' />ফেসবুকে এক ক্লিকেই শেয়ার করতে পারবেন</li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="course-outline">
                                    <div className="youtube-add">
                                        {
                                            loaddig ? <>
                                                <div class="spinner-grow text-primary" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </>
                                                :
                                                <iframe width="560" height="215" className='w-100' src={`https://www.youtube.com/embed/${course?.entryVideo}`} title="YouTube video player" frameBorder='1' allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                        }

                                    </div>
                                    <div className="outline-extra cBorder p-2">
                                        <h6 className='text-end pt-3 pb-3 fw-bold fs-4'>৳ {course?.price}</h6>
                                        <div className="btn btn-success w-100 d-block fs-5" onClick={handleBuy}>কোর্সটি কিনুন  <FontAwesomeIcon icon={faHandPointRight} className='ms-1' /></div>
                                        <div className="course-outline-btn mt-5">
                                            <div className="row gy-4">
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="outline1">
                                                        <div className="outline-logo">
                                                            <FontAwesomeIcon icon={faUsers} />
                                                        </div>
                                                        <div className="outline-title">
                                                            <h6>কোর্সটি করেছেন</h6>
                                                            <p>{course?.price} জন</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="outline1">
                                                        <div className="outline-logo">
                                                            <FontAwesomeIcon icon={faStopwatch} />
                                                        </div>
                                                        <div className="outline-title">
                                                            <h6>সময় লাগবে</h6>
                                                            <p>{course?.revision} ঘণ্টা</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="outline1">
                                                        <div className="outline-logo">
                                                            <FontAwesomeIcon icon={faPlay} />
                                                        </div>
                                                        <div className="outline-title">
                                                            <h6>ভিডিও</h6>
                                                            <p>{course?.live} টি </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="outline1">
                                                        <div className="outline-logo">
                                                            <FontAwesomeIcon icon={faPlane} />
                                                        </div>
                                                        <div className="outline-title">
                                                            <h6>কুইজ</h6>
                                                            <p>{course?.test}  টি </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="phoneCall mt-5">
                                        <h5 className='fs-5 fw-bold'>কোর্সটি সম্পর্কে বিস্তারিত জানতে <span className='text-primary'><FontAwesomeIcon icon={faPhone} /> ফোন করুন (16910)</span></h5>
                                    </div>
                                    <div className="our-questions mt-5">
                                        <h5 className='fw-bold mb-3'>আপনাদের সাধারণ প্রশ্নোত্তর</h5>
                                        <div class="accordion accordion-flush" id="accordionFlushExample">
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="flush-headingOne">
                                                    <button class="accordion-button collapsed fs-4" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                                        ১. কোর্সটি কীভাবে কিনবো?
                                                    </button>
                                                </h2>
                                                <div id="flush-collapseOne" class="accordion-collapse collapse show text-secondary" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                                    <div class="accordion-body fs-5">লগ-ইন করার সময় নিচে "Forget Password / পাসওয়ার্ড ভুলে গিয়েছি" নামে একটি অপশন পাবে। সেটির মাধ্যমে আপনি পাসওয়ার্ড রিসেট করে নতুন পাসওয়ার্ড নিতে পারবেন। পাসওয়ার্ড রিসেট করার পরে আপনি পুনরায় নতুন পাসওয়ার্ড সেট করতে পারবেন।</div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="flush-headingTwo">
                                                    <button class="accordion-button collapsed fs-4" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                                                        ২. কোনো টেকনিকাল সমস্যা কিভাবে রিপোর্ট করব?
                                                    </button>
                                                </h2>
                                                <div id="flush-collapseTwo" class="accordion-collapse collapse text-secondary" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                                    <div class="accordion-body fs-5">লগ-ইন করার সময় নিচে "Forget Password / পাসওয়ার্ড ভুলে গিয়েছি" নামে একটি অপশন পাবে। সেটির মাধ্যমে আপনি পাসওয়ার্ড রিসেট করে নতুন পাসওয়ার্ড নিতে পারবেন। পাসওয়ার্ড রিসেট করার পরে আপনি পুনরায় নতুন পাসওয়ার্ড সেট করতে পারবেন।</div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header" id="flush-headingThree">
                                                    <button class="accordion-button collapsed fs-4" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                                                        ৩. ক্লাস করার জন্য কি প্রয়োজন হবে ?
                                                    </button>
                                                </h2>
                                                <div id="flush-collapseThree" class="accordion-collapse collapse text-secondary" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                                                    <div class="accordion-body fs-5">ইন্টারনেট সংযোগ (ওয়াইফাই বা মোবাইল ইন্টারনেট)
                                                        স্মার্টফোন অথবা পিসি</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="download-app mt-5">
                                        <h6 className='text-secondary fs-5 fw-bold'>আমাদের মোবাইল অ্যাপ <span className='text-primary' onClick={() => window.open('https://play.google.com/store/apps/details?id=com.a10minuteschool.tenminuteschool')} style={{ cursor: 'pointer' }}>ডাউনলোড করুন</span></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </section>
    );
};
export default JobPreperationDetails;